import { Box, Typography, LinearProgress } from '@mui/material';
import styled from 'styled-components';
import colors from '../../../../../styles/colors';

const StyledBox = styled(Box)`
  width: 100%;
  min-width: 150px;
`;

// The track was a hardcoded cool grey and the bar rode MUI's primary, so after the
// retheme a lime fill sat on it at 1.07:1 — the bar was invisible at any value. Track
// moves on-palette and the fill to deep green, which reads at 4.57:1 against it.
const StyledLinearProgress = styled(LinearProgress)`
  height: 8px;
  border-radius: 4px;
  background-color: ${colors.shades.gamma1};

  & .MuiLinearProgress-bar {
    border-radius: 4px;
    background-color: ${colors.base.secondary};
  }
`;

const StyledTypography = styled(Typography)`
  margin-bottom: 8px;
  font-size: 12px;
`;

const StyledProgressHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledPercentage = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
`;

export {
  StyledBox,
  StyledLinearProgress,
  StyledTypography,
  StyledProgressHeader,
  StyledPercentage,
};
